export default __webpack_public_path__ + "static/media/white-export-data-icon.48685649.svg";